module.exports = __webpack_public_path__ + "img/N3 200X200.be139af1.png";